import React from 'react';
import { useTranslation } from 'react-i18next';
import NavigationMenu from './NavigationMenu';

const SECTIONS = [
  { to: '/cyber-bulletin', key: 'overview' },
  { to: '/cyber-bulletin/victims', key: 'victims' },
  { to: '/cyber-bulletin/groups', key: 'groups' },
  { to: '/cyber-bulletin/trends', key: 'trends' },
];

export default function CyberBulletinMenu(props) {
  const { t } = useTranslation();
  return <NavigationMenu {...props} id="cyber-bulletin" icon="report" label={t('nav.cyberBulletin')}
    sections={SECTIONS.map(section => ({ ...section, label: t(`cyberBulletin.tabs.${section.key}`) }))} />;
}
